import axios from 'axios'
import moment from 'moment'
import store from '@/store'
import router from '@/router'

export const HTTP_CLIENT = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true, // gestion cookies coté server
  headers: {
    'Content-Type': 'application/json'
  }
})

HTTP_CLIENT.interceptors.response.use((response) => {
  return response
}, async function (err) {
  if (err.response !== undefined && err.response.status === 401 && !router.currentRoute.meta.noguard) {
    store.dispatch('auth/LOGOUT')
  } else {
    return Promise.reject(err)
  }
})

// TODO DEPLACER LOGIN
/* const login = 'jeremy'
const password = '#Ekidai8p'
const clientId = '2_5nt0f31fjw088s4488o8gw4c48ck08s04gckgsgo0c8888gscw'
const secret = '2me0kga904w048wgkooogc84o0cgwsscg8gc0o4sssk4gcg4ck' */
const API_URL = `https://pim.test.edisac.com`

const login = 'pim_0857'
const password = 'df485bf35'
const clientId = '1_4q9yufk54pwkks004gckwswoccckks8wkkooos08cgoo4gkwwc'
const secret = '30qmmkf3oruo0g0c8o04g0o4k88csoogo08c44ooc80o4ocoo0'

let Bearer = {
  access_token: undefined,
  expires_in: moment().unix(),
  refresh_token: undefined
}

const generateBearer = async () => {
  try {
    // si pas de token ou token expire
    if (!Bearer.access_token || Bearer.expires_in <= moment().unix() + 100) {
      // Recuperation du bearer
      let { data } = await axios({
        method: 'post',
        url: `${API_URL}/api/oauth/v1/token`,
        data: {
          username: login,
          password: password,
          grant_type: 'password'
        },
        headers: {
          'Content-Type': 'application/json',
          // eslint-disable-next-line new-cap
          Authorization: 'Basic ' + new Buffer.from(clientId + ':' + secret).toString('base64')
        }
      })
      Bearer.access_token = data.access_token
      Bearer.expires_in = moment.unix() + data.expires_in
      Bearer.refresh_token = data.refresh_token
    }
    return Bearer.access_token
  } catch (err) {
    // remonté dans le PIM via api
    console.log('TODO erreur Bearer', err)
  }
}

export const HTTP_PIM = axios.create({
  baseURL: API_URL + '/api/rest/v1/',
  headers: {
    'Content-Type': 'application/json'
  }
})

HTTP_PIM.interceptors.request.use(
  async config => {
    config.headers.authorization = 'Bearer ' + await generateBearer()
    return config
  },
  error => Promise.reject(error)
)

export const HTTP_PIM_IMG = axios.create({
  baseURL: API_URL + '/api/rest/v1/',
  responseType: 'arraybuffer',
  headers: { 'content-type': 'multipart/form-data' }
})

HTTP_PIM_IMG.interceptors.request.use(
  async config => {
    config.headers.authorization = 'Bearer ' + await generateBearer()
    return config
  },
  error => Promise.reject(error)
)
